import type {FC} from 'react';
import {Box, Progress, ProgressTypes} from '@wellstone-solutions/web';

interface LoadingIndicatorProps {
  color?: 'secondary' | 'primary';
  size?: number;
  stylesOverride?: Record<string, string | number>;
}

export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  color = 'secondary',
  size = 32,
  stylesOverride = {},
}) => (
  <Box
    data-testid="loading-indicator"
    sx={[
      {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        marginBottom: 4,
      },
      stylesOverride,
    ]}>
    <Progress color={color} progressType={ProgressTypes.circular} size={size} />
  </Box>
);
